// src/components/Onboarding/BackButton.js

import React from 'react';

/**
 * BACK BUTTON COMPONENT
 * 
 * Simple left arrow button for navigating back to previous slide.
 * Positioned in top-left corner of SlideShell.
 * 
 * HOW TO USE:
 * <BackButton onClick={goBack} />
 * 
 * PROPS:
 * - onClick: Function to call when back button is pressed
 * 
 * STYLING:
 * - Circular background with left arrow icon
 * - Matches mobile design patterns
 * - Touch-friendly size for mobile
 */

export default function BackButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200"
      aria-label="Go back"
    >
      <svg 
        width="16" 
        height="16" 
        viewBox="0 0 16 16" 
        fill="none" 
        className="text-gray-700"
      >
        <path 
          d="M10 12L6 8L10 4" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}